export const defaultImage =
  "https://readapp.ams3.digitaloceanspaces.com/example/lounge/dysh-app-icon.png";
export const defaultPlaylistImage = "https://readapp.ams3.digitaloceanspaces.com/default-playlist-image.jpg";
